import { Modal, ModalBody } from "react-bootstrap";
import { ImCross } from "react-icons/im";

export function VideoModal({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: any;
}) {
  return (
    <Modal
      show={isOpen}
      onHide={() => handleClose(false)}
      centered
      dialogClassName="video-modal-dialog"
    >
      <ModalBody>
        <div
          className="video-modal-close-button"
          onClick={() => handleClose(false)}
        >
          <ImCross />
        </div>
        <video controls autoPlay className="w-100">
          <source
            src={"https://assets.thriwe.com/NBF/NBF+Journey+video.mp4"}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </ModalBody>
    </Modal>
  );
}
